import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5dadf780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-dam" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在河流:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "工程类型:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系人:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系电话:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "行政区划代码:", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "行政区划名称:", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "descriptions-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "运行管理单位:", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "descriptions-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "工程地址:", -1))
const _hoisted_30 = { class: "value" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogDiversionWater',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).xmmc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).szhl || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).gclx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(data).lxr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data).lxfs || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(data).xzqhdm || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(data).xzqhmc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).yxgldw || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(data).dd || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})